<div class="page-layout">
    <div class="header" *ngIf="displayHeader">
        <h2>{{ 'activities.title' | translate }}</h2>
    </div>
    <content class="content inner-scroll">
        <router-outlet></router-outlet>
    </content>
</div>

